<template>
    <div class="covid-alert">
        <b-alert show variant="warning">
            <strong>Know before you go.</strong> The restrictions surrounding COVID-19 change often. Please stay
            informed before traveling. Stay safe.
        </b-alert>
    </div>
</template>

<script>
    export default {
        name: 'CovidAlert',
    }
</script>

<style scoped>
    .covid-alert {
        margin-top: 15px;
    }
</style>
